var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentConfirmation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34.447c9.264 0 16.934-7.67 16.934-16.933C33.934 8.267 26.247.58 16.984.58 7.735.58.065 8.267.065 17.514c0 9.263 7.687 16.933 16.934 16.933zm-2.274-8.417c-.565 0-1.013-.249-1.478-.813l-4.798-5.91c-.249-.316-.398-.714-.398-1.08 0-.78.614-1.377 1.361-1.377.465 0 .88.182 1.262.697l3.968 5.13 7.72-12.368c.315-.515.746-.764 1.195-.764.73 0 1.427.481 1.427 1.278 0 .365-.215.764-.415 1.096l-8.45 13.298c-.365.548-.83.813-1.394.813z",
    fill: "#307BF6"
  })));
}

export default SvgPaymentConfirmation;